import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { supplierUrls } from "../../URL/ApplicationUrls";
import { deleteSuccessMessage } from "../../Messages/successMessages";
import { MdmApiError } from "../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";

export const useDeleteSupplier = (supplierId: number | string | undefined) => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (id: number | string | undefined) => {
      await axios.delete(supplierUrls.supplierWithId(id).apiUrl);
    },
    onSuccess: async () => {
      toast.success(deleteSuccessMessage(supplierId, "Supplier"));
      navigate(supplierUrls.base.uiPath);
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
